import React from 'react'
import Grid from '@material-ui/core/Grid'
import BreakHTMLFooter from 'steps/BreakHTMLFooter'
import getStepName from 'util/stepTypeStrings'

/*
    StartSlide is almost identical to LockedStep
    if you make changes here, check there also

*/

const StartSlide = ({
  headline,
  para,
  footer,
  bgImageExists,
  backgroundImageId,
  backgroundColor,
  onStartClicked,
  HtmlFooter,
  stepType,
}) => {
  let style = {}

  if (backgroundColor) {
    style.backgroundColor = backgroundColor
  }

  if (backgroundImageId) {
    style.backgroundImage = `url(${process.env.SITE_ASSET_URL}/${backgroundImageId})`
  }
  const stepName = getStepName(stepType)
  return (
    <div
      className={`start-slide ${
        HtmlFooter ? `has-html-footer` : `no-html-footer`
      }`}
      style={style}
    >
      <div className="container">
        <Grid container justify="center" spacing={2}>
          <Grid item xs={12} md={9}>
            <div
              className={`start-slide__content${
                !bgImageExists ? ' no-background' : ''
              }`}
            >
              <h2 dangerouslySetInnerHTML={{ __html: headline }}></h2>
              <p
                className="start-body"
                dangerouslySetInnerHTML={{ __html: para }}
              ></p>
              <div>
                {/* added ID is for hacky css overrides in beaker. */}
                <span
                  id="start-slide-button"
                  className="btn start-button"
                  onClick={onStartClicked}
                >
                  Start {stepName}
                </span>
              </div>
              <p
                className="start-footer"
                dangerouslySetInnerHTML={{ __html: footer }}
              ></p>
            </div>
          </Grid>
        </Grid>
      </div>
      {HtmlFooter && (
        <div className="sponsored-flow-panel--footer sponsored-flow-panel-3--footer">
          <HtmlFooter />
        </div>
      )}
    </div>
  )
}

export default StartSlide
